import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  templates: [],
  templateVersions: [],
  totalCommunications: 0,
  selectAllField: false,
  selectedCommunications: []
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
